/**
 * @file Contém as configurações de acesso para a API do Ozmap.
 * Manter as credenciais em um arquivo separado facilita a gestão e a segurança,
 * permitindo, por exemplo, que este arquivo seja facilmente ignorado pelo Git
 * e substituído por variáveis de ambiente em um ambiente de produção.
 */

export const ozmapConfig = {
	/**
	 * A URL base da API do Ozmap.
	 * Substitua pela URL da sua instância (produção ou sandbox).
	 * Ex: 'https://api.ozmap.com.br/api/v2'
	 * @type {string}
	 */
	API_URL: process.env.REACT_APP_OZMAP_API_URL || 'https://connect10.ozmap.com.br:9994/api/v2',

	/**
	 * A sua chave de API (API Key) para autenticação.
	 * Esta chave deve ser tratada como uma senha e mantida em segurança.
	 * @type {string}
	 */
	API_TOKEN: process.env.REACT_APP_OZMAP_API_TOKEN || '',
	PROJECTS: {
		'BOTUCATU': '667f0ce22459010020f95161',
		'LENCOIS PAULISTA': '66719531d99d850014538c73',
		'PRATANIA' : '667dc1242459010020f94b0b',
		'AREIOPOLIS' : '67607bfdf7c9534f3124ca59',
		'SAO MANUEL' : '6761b1d8f7c9534f3128601c',
		'1 Geral (Backbones Intercidades)' : '6761c6753cdaca74264f893e',
		'T20' : '67a4b3929214af52eb9d539e',
		'T7' : '67a4ba675efc279f455ad5b8',
	}
};